export {places}


const places = [
    {
      id: 1,
      title: 'La maison et le jardin de Georges Clémenceau',
      description: 'Cette maison de pêcheur simple a été la résidence secondaire de Georges Clémenceau, surnommé "Le Tigre", de 1919 jusqu\'à sa mort en 1929. Le jardin, conçu par Clémenceau lui-même, offre une vue imprenable sur l\'océan Atlantique et abrite une collection de sculptures et d\'objets d\'art.',
      interest: 'Ce site est un lieu incontournable pour les amateurs d\'histoire et de politique. Il permet de découvrir l\'intimité de l\'un des hommes d\'État les plus importants de la France.',
      practicalInfo: 'La maison et le jardin sont ouverts au public du 1er avril au 30 septembre. La visite est libre ou guidée.',
      image: 'images/maison-clemenceau.jpg',
      url: 'https://www.maison-de-clemenceau.fr/',
      alt: 'Description de l\'image 1',
      src: './assets/imgLieu/lieu1.webp',
      name: 'Titre de l\'image 1'
    },
    {
      id: 2,
      title: 'L\'église de Saint-Vincent',
      description: 'Cette église romane du XIIe siècle est classée monument historique. Elle est dédiée à Saint-Vincent, patron des vignerons. L\'église abrite un beau retable du XVIIe siècle et des fonts baptismaux du XVIe siècle.',
      interest: 'L\'église de Saint-Vincent est un bel exemple de l\'architecture romane en Vendée. Elle offre un cadre paisible pour une visite spirituelle ou historique.',
      practicalInfo: 'L\'église est ouverte au public tous les jours.',
      image: 'images/eglise-saint-vincent.jpg',
      url: 'https://fr.wikipedia.org/wiki/%C3%89glise_Saint-Vincent_de_Saint-Vincent-sur-Jard',
      alt: 'Description de l\'image 2',
      src: './assets/imgLieu/lieu2.webp',
      name: 'Titre de l\'image 2'
    },
    {
        id: 3,
        title: "Randonnées à Saint Vincent sur Jard",
        description: "Découvrez les sentiers pittoresques de Saint Vincent sur Jard, où la nature s'offre à vous dans toute sa splendeur. Entre dunes, forêts et marais, chaque randonnée est une invitation à l'émerveillement.",
        interest: "Les randonnées de Saint Vincent sur Jard sont l'occasion parfaite pour se reconnecter avec la nature et admirer des paysages côtiers à couper le souffle.",
        practicalInfo: "Les sentiers sont accessibles gratuitement et offrent divers niveaux de difficulté, adaptés à tous les amateurs de plein air.",
        image: "images/sentier-saint-vincent-sur-jard.jpg",
        url: "https://www.destination-vendeegrandlittoral.com/quoi-faire/balade/a-pied/circuit-de-la-pointe-du-payre/",
        alt: "Description de l'image 3",
        src: "./assets/imgLieu/lieu3.webp",
        name: "Titre de l'image 3"
    },
    {
      id: 4,
      title: 'Les plages de Saint-Vincent-sur-Jard',
      description: 'La commune de Saint-Vincent-sur-Jard possède trois plages de sable fin : la plage de la Ragnette, la plage du Goulet et la plage de Clémenceau. Ces plages sont surveillées en été et offrent de nombreuses possibilités d\'activités nautiques.',
      interest: 'Les plages de Saint-Vincent-sur-Jard sont idéales pour se détendre, bronzer et profiter des sports nautiques. Elles offrent un cadre magnifique pour des vacances en famille ou entre amis.',
      practicalInfo: 'Les plages de Saint-Vincent-sur-Jard sont accessibles gratuitement toute l\'année.',
      image: 'images/plage-ragnette.jpg',
      url: 'https://www.destination-vendeegrandlittoral.com/quoi-faire/plages/',
      alt: 'Description de l\'image 4',
      src: './assets/imgLieu/lieu4.webp',
      name: 'Titre de l\'image 2'
    }
  ];
  export default places;



